// extracted by mini-css-extract-plugin
module.exports = {"clock":"DateTime_clock__phjme"};